import { Injectable } from '@angular/core';
import ROUTES from '../config/settings.config';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  paths = ROUTES;

  constructor() { }

  compare(path: string): boolean {
    const found = this.paths.find((item: any) => item.path === path);
    if (found) {
      return found.back;
    }
    return true;
  }

  getBackRoute(path:string){
    const index = this.paths.findIndex((item:any) => item.path === path);
    const backRoute = index > 0 ? this.paths[index -1] : null;

    return backRoute?.path;
  }

  getNextRoute(path:string){
    const index = this.paths.findIndex((item:any) => item.path === path);
    const backRoute = index > 0 ? this.paths[index +1] : null;

    return backRoute?.path;
  }

}
